import { formatUtcDate } from './get-formatted-date';
const translateAvailability = (t, key, date) => String(t(`grant_availability|${key}`, date === undefined ? undefined : { date }));
export const resolveGrantAvailabilityStatus = (grant) => {
    var _a, _b, _c;
    if (grant.archived_at != null)
        return 'archived';
    return ((_c = (_b = (_a = grant.grant_availability) === null || _a === void 0 ? void 0 : _a.effective_availability_status) !== null && _b !== void 0 ? _b : grant.application_status) !== null && _c !== void 0 ? _c : 'unknown');
};
export const getGrantAvailabilityPresentation = (grant, t, locale) => {
    var _a, _b;
    const status = resolveGrantAvailabilityStatus(grant);
    const availability = grant.grant_availability;
    if (status === 'archived' || status === 'suspending') {
        const key = status === 'archived' ? 'archived' : 'suspending';
        const message = translateAvailability(t, key);
        return { items: [message], compact: message, status };
    }
    if (availability) {
        const semanticKey = {
            continuous: 'openContinuously',
            until_funds_exhausted: 'untilFundsExhausted',
            announced_dates_unknown: 'datesToBeAnnounced',
            not_currently_accepting: 'notCurrentlyAccepting',
            information_unavailable: 'informationUnavailable',
        }[(_a = availability.intake_kind) !== null && _a !== void 0 ? _a : ''];
        if (semanticKey) {
            const message = translateAvailability(t, semanticKey);
            return { items: [message], compact: message, status };
        }
        const openingDate = formatUtcDate(availability.display_period_starts_at, locale);
        const closingDate = formatUtcDate(availability.display_period_ends_at, locale);
        const items = [];
        let openingMessage = '';
        let closingMessage = '';
        let missingDeadlineMessage = '';
        if (openingDate) {
            openingMessage = translateAvailability(t, 'openingDate', openingDate);
            items.push(openingMessage);
        }
        if (closingDate) {
            closingMessage = translateAvailability(t, 'closingDate', closingDate);
            items.push(closingMessage);
        }
        const dateBasedIntake = [
            'fixed_window',
            'deadline_only',
            'open_from_date',
            'recurring',
        ].includes((_b = availability.intake_kind) !== null && _b !== void 0 ? _b : '');
        if (!closingDate && (openingDate || dateBasedIntake)) {
            missingDeadlineMessage = translateAvailability(t, 'deadlineUnknown');
            items.push(missingDeadlineMessage);
        }
        if (items.length === 0) {
            const message = translateAvailability(t, status === 'closed'
                ? 'notCurrentlyAccepting'
                : 'informationUnavailable');
            return { items: [message], compact: message, status };
        }
        return {
            items,
            compact: closingMessage || missingDeadlineMessage || openingMessage || items[0],
            status,
        };
    }
    const message = translateAvailability(t, status === 'closed' ? 'notCurrentlyAccepting' : 'informationUnavailable');
    return { items: [message], compact: message, status };
};
